import React from 'react';
import FeatureForm from './FeatureForm';
import styles from './FeatureFormContainer.module.css';

function FeatureFormContainer(props) {
  const { feature } = props;
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Feature: {feature}</h1>
      <FeatureForm flaggingType="course" feature={feature} {...props} />
      <FeatureForm flaggingType="isbn" feature={feature} {...props} />
    </div>
  );
}

export default FeatureFormContainer;
